import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import church from '../../assets/images/home/church.png';
import ActionButton from 'components/ui/buttons/action-button';
import Animated from 'components/generals/AnimatedComponent';
import { Link } from 'react-router-dom';
import image_roots from 'assets/images/home/section_1/1.png';
import Interviewcomponent from 'components/interview/index';
export default function Home__section__1() {
    const location = useLocation();

    useEffect(() => {
        const hash = location.hash;
        if (hash) {
            setTimeout(() => {
                const element = document.querySelector(hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 0);
        }
    }, [location]);
    return (
        <main
            className="nv__section nv__section--no-margin nv__section--init  nv__hp__section__1"
            id="home"
        >
            <section className="nv__section__container">
                <section className="section__block">
                    {/* <Interviewcomponent name="Jose Ramon" age={34} /> */}
                    <Animated animation={'animate__fadeInDown animate__delay-1s '}>
                        <h1>Descrubre</h1>
                    </Animated>
                    <Animated animation={'animate__fadeInDown animate__delay-2s'}>
                        <h3>Las oportunidades</h3>
                    </Animated>

                    <Animated animation={'animate__fadeInDown animate__delay-3s'}>
                        <p className="squareInfo">de la industria del taro mexicano.</p>
                    </Animated>
                    <Animated animation={'animate__fadeInDown animate__delay-3s'}>
                        <p className="blockInfo">
                            Explora las ventajas que ofrece la industria de este mercado en auge.
                        </p>
                    </Animated>

                    <Animated animation={'animate__fadeInDown animate__delay-3s'}>
                        <Link to="https://wa.me/5215531151431" target="_blank">
                            <ActionButton text="¿COMO FUNCIONA?" type="rounded" color="black" />
                        </Link>
                    </Animated>
                </section>

                <section className="section__block">
                    <div className="roots__image__content">
                        <div className="roots__image__content__asset">
                            <Animated animation={'animate__fadeInUp animate__delay-1s'}>
                                <img src={image_roots} />
                            </Animated>
                        </div>

                        <div className="roots__image__content__info">
                            <div className="porcent">
                                <Animated animation={'animate__fadeInDown animate__delay-1s'}>
                                    <span>+</span>
                                    <h1>30%</h1>
                                </Animated>
                            </div>
                            <Animated animation={'animate__fadeInLeft animate__delay-1s'}>
                                <p className="info">
                                    Las raíces y tubérculos han demostrado ser un negocio rentable,
                                    con retorno constante.
                                </p>

                                <div className="bar">
                                    <div className="progress"></div>
                                </div>
                            </Animated>
                        </div>
                    </div>
                </section>
            </section>
        </main>
    );
}
